module.exports = __webpack_public_path__ + "assets/img/btn-back-e034cc0d.png";